export const GRAPH_PERMISSIONS = {
    TABOOLA_ADS_CREATIVE_BAR_GRAPH_VIEW: 'TABOOLA_ADS_CREATIVE_BAR_GRAPH_VIEW',
    TABOOLA_ADS_CREATIVE_LINE_GRAPH_VIEW: 'TABOOLA_ADS_CREATIVE_LINE_GRAPH_VIEW',
};
